import { styled , MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
`;